export default {"src":"/_next/static/media/pen_regular.7bc5ed60.svg","height":24,"width":24};